'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _LegacyTobaccoGrade = require('./LegacyTobaccoGrade.css');

var _LegacyTobaccoGrade2 = _interopRequireDefault(_LegacyTobaccoGrade);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegacyTobaccoGrade = (_dec = (0, _reactCssModules2.default)(_LegacyTobaccoGrade2.default, { allowMultiple: false }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LegacyTobaccoGrade, _Component);

  function LegacyTobaccoGrade(props) {
    (0, _classCallCheck3.default)(this, LegacyTobaccoGrade);
    return (0, _possibleConstructorReturn3.default)(this, (LegacyTobaccoGrade.__proto__ || (0, _getPrototypeOf2.default)(LegacyTobaccoGrade)).call(this, props));
  }

  (0, _createClass3.default)(LegacyTobaccoGrade, [{
    key: 'render',
    value: function render() {
      var intGrade = _format2.default.tobaccoScoreAsInt(this.props.score);
      var style = _format2.default.join('grade', intGrade);
      var tip = '<div style=\'width:200px;text-align:left;white-space:normal;\'>';
      if (this.props.legacy) {
        var legacyGrade = _format2.default.scoreTobaccoLegacy(this.props.score);
        style = _format2.default.join('lgrade', this.props.score);
        tip += 'As of August 2019, we\'ve updated our tobacco grades from a "five star" system to a letter grade system. This is the legacy grade the fund would have earned before the change. Visit our How it Works page to learn more about the new grades';
        tip += '</div>';
        return _react2.default.createElement(
          'div',
          {
            styleName: style,
            'data-multiline': true,
            'data-effect': 'solid',
            'data-html': true,
            'data-tip': tip,
            'data-for': 'lgrade-tooltip',
            'data-place': 'bottom'
          },
          legacyGrade,
          _react2.default.createElement(_reactTooltip2.default, { id: 'lgrade-tooltip' })
        );
      }
      var letterGrade = _format2.default.tobaccoScore(this.props.score);
      style = this.props.large ? style + '-large' : style;
      var wrapStyle = this.props.large ? 'grade-wrap-large' : 'grade-wrap';
      switch (letterGrade) {
        case 'A':
          tip += 'Fund is not invested in tobacco companies, and not invested in tobacco-promoting entertainment companies';
          break;
        case 'B':
          tip += 'Fund is not invested in tobacco companies, but is invested in tobacco-promoting entertainment companies';
          break;
        case 'F':
          tip += 'Fund is invested in tobacco companies, and may also be invested in tobacco-promoting entertainment companies';
          break;
        case 'E':
          tip += 'Offered by a fund family that frequently engages the companies it invests in to push for corporate behavior towards sustainability';
          break;
        default:
          tip += 'ERR';
          break;
      }
      tip += '</div>';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: wrapStyle },
          _react2.default.createElement(
            'div',
            {
              styleName: style,
              'data-multiline': true,
              'data-effect': 'solid',
              'data-html': true,
              'data-tip': tip,
              'data-for': 'grade-tooltip',
              'data-place': this.props.large ? 'bottom' : 'left'
            },
            letterGrade
          ),
          _react2.default.createElement(_reactTooltip2.default, { id: 'grade-tooltip' })
        )
      );
    }
  }]);
  return LegacyTobaccoGrade;
}(_react.Component), _class2.propTypes = {
  score: _react.PropTypes.string.isRequired,
  large: _react.PropTypes.bool,
  legacy: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = LegacyTobaccoGrade;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LegacyTobaccoGrade/LegacyTobaccoGrade.js
// module id = 1278
// module chunks = 0